import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { trafficSourceState } from '../state';
import { getTrafficSourceFromURL } from '../utils/trafficSource';

/**
 * Хук для инициализации источника трафика из URL
 * Должен использоваться в корневом компоненте приложения
 */
export const useTrafficSourceInit = () => {
  const setTrafficSource = useSetRecoilState(trafficSourceState);

  useEffect(() => {
    const source = getTrafficSourceFromURL();
    setTrafficSource(source);
    
    // Логируем для отладки
    console.log('Traffic source detected:', source);
  }, [setTrafficSource]);
};
